import LocalizedProductTile from './LocalizedProductTile';

export default LocalizedProductTile;
